import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import AboutMeContext from '../AboutMeContext';
import { createGqlContext } from './create-gql-context';
const AboutMeProvider = ({ uri, children }) => {
    const provider = useMemo(() => createGqlContext(uri), [uri]);
    return (_jsx(AboutMeContext.Provider, Object.assign({ value: provider }, { children: children })));
};
export default AboutMeProvider;
